import { takeLatest, put } from 'redux-saga/effects';
import * as TYPES from '../actions/types';
import { getClientTreatmentPlanSign, loaderAction, saveClientTreatmentPlanSign, saveTreatmentPlan, saveTreatmentPlanReSignNotifications } from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { GET_CLIENT_TREATMENT_PLAN_SIGN } from '../actions/types';
import { TreatmentPlan } from '../../services/treatment-plan';

export function* getTreatmentPlanSaga() {
  try {
    yield takeLatest(TYPES.GET_TREATMENT_PLAN, getTreatmentPlanWorker);
  } catch (err) {
  }
}

function* getTreatmentPlanWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield TreatmentPlan.getCP(param['payload']);
    if (param['payload']) {
      yield put(saveTreatmentPlan([response.resultData]));
    } else {
      yield put(saveTreatmentPlan(response.resultData));
    }
    yield put(loaderAction(false));
  } catch (e) {
  }
}

export function* getClientTreatmentPlanSignSaga() {
  yield takeLatest(GET_CLIENT_TREATMENT_PLAN_SIGN, clientTreatmentPlanSignAction);
}


function* clientTreatmentPlanSignAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield TreatmentPlan.getTpSign(param['payload']);
    if (response.resultData) {
      yield put(saveClientTreatmentPlanSign([response.resultData]));
    }
    yield put(loaderAction(false))
  } catch (e) {
  }
}


export function* ApplyClientSignatureSaga() {
  try {
    yield takeLatest(TYPES.APPLY_CLIENT_SIGNATURE, ApplyClientSignatureSagaActions);
  } catch (err) {
    console.error('ApplyClientSignatureSaga error:', err);
  }
}
function* ApplyClientSignatureSagaActions(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield TreatmentPlan.applySignature(param['payload'].payload);
    yield put(loaderAction(false));
    if (response.resultData) {
      yield put(getClientTreatmentPlanSign(param['payload'].id));
    }
  } catch (e) {
  }
}

export function* getTreatmentPlanReSignNotificationSaga() {
  try {
    yield takeLatest(TYPES.GET_CP_RESIGN_NOTIFICATION, getTreatmentPlanReSignNotificationWorker);
  } catch (err) {
  }
}

function* getTreatmentPlanReSignNotificationWorker() {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield TreatmentPlan.getTreatmentPlanReSignNotifications();
    yield put(saveTreatmentPlanReSignNotifications(response?.resultData));
    yield put(loaderAction(false));
  }
  catch (e) {
    yield put(loaderAction(false));
    console.error(e);
  }
}


